import { defineComponent as s, openBlock as t, createElementBlock as o, mergeProps as v, unref as e, renderSlot as m, createElementVNode as H, createCommentVNode as d } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, i = { key: 1 }, p = { key: 2 }, u = { key: 3 }, L = { key: 4 }, M = { key: 5 }, g = {
  name: "ScalarIconBarricade"
}, w = /* @__PURE__ */ s({
  ...g,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const V = n, { bind: r, weight: a } = h(V);
    return (Z, l) => (t(), o("svg", v({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      m(Z.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", A, l[0] || (l[0] = [
        H("path", { d: "M224,60H32A20,20,0,0,0,12,80v72a20,20,0,0,0,20,20H52v28a12,12,0,0,0,24,0V172H180v28a12,12,0,0,0,24,0V172h20a20,20,0,0,0,20-20V80A20,20,0,0,0,224,60Zm-4,59L185,84h35Zm-43,29L113,84H151l64,64Zm-72,0L41,84H79l64,64ZM36,113l35,35H36Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", i, l[1] || (l[1] = [
        H("path", {
          d: "M232,80v68L156,72h68A8,8,0,0,1,232,80ZM32,72a8,8,0,0,0-8,8v4l76,76h72L84,72Z",
          opacity: "0.2"
        }, null, -1),
        H("path", { d: "M224,64H32A16,16,0,0,0,16,80v72a16,16,0,0,0,16,16H56v32a8,8,0,0,0,16,0V168H184v32a8,8,0,0,0,16,0V168h24a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64Zm0,64.69L175.31,80H224ZM80.69,80l72,72H103.31L32,80.69V80ZM32,103.31,80.69,152H32ZM224,152H175.31l-72-72h49.38L224,151.32V152Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", p, l[2] || (l[2] = [
        H("path", { d: "M224,64H32A16,16,0,0,0,16,80v72a16,16,0,0,0,16,16H56v32a8,8,0,0,0,16,0V168H184v32a8,8,0,0,0,16,0V168h24a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64ZM32,152V92l60,60Zm192,0H167.31l-72-72H164l60,60v12Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", u, l[3] || (l[3] = [
        H("path", { d: "M224,66H32A14,14,0,0,0,18,80v72a14,14,0,0,0,14,14H58v34a6,6,0,0,0,12,0V166H186v34a6,6,0,0,0,12,0V166h26a14,14,0,0,0,14-14V80A14,14,0,0,0,224,66Zm2,14v53.52L170.48,78H224A2,2,0,0,1,226,80ZM32,78H81.52l76,76h-55L30,81.52V80A2,2,0,0,1,32,78Zm-2,74V98.48L85.52,154H32A2,2,0,0,1,30,152Zm194,2H174.48l-76-76h55L226,150.48V152A2,2,0,0,1,224,154Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", L, l[4] || (l[4] = [
        H("path", { d: "M224,64H32A16,16,0,0,0,16,80v72a16,16,0,0,0,16,16H56v32a8,8,0,0,0,16,0V168H184v32a8,8,0,0,0,16,0V168h24a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64Zm0,64.69L175.31,80H224ZM80.69,80l72,72H103.31L32,80.69V80ZM32,103.31,80.69,152H32ZM224,152H175.31l-72-72h49.38L224,151.32V152Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", M, l[5] || (l[5] = [
        H("path", { d: "M224,68H32A12,12,0,0,0,20,80v72a12,12,0,0,0,12,12H60v36a4,4,0,0,0,8,0V164H188v36a4,4,0,0,0,8,0V164h28a12,12,0,0,0,12-12V80A12,12,0,0,0,224,68Zm4,12v58.34L165.66,76H224A4,4,0,0,1,228,80ZM32,76H82.34l80,80H101.66L28,82.34V80A4,4,0,0,1,32,76Zm-4,76V93.66L90.34,156H32A4,4,0,0,1,28,152Zm196,4H173.66l-80-80h60.68L228,149.66V152A4,4,0,0,1,224,156Z" }, null, -1)
      ]))) : d("", !0)
    ], 16));
  }
});
export {
  w as default
};
